// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* ===============================
   AI LAUNCHER
================================ */

.galax-agent-launcher {
  position: fixed;
  right: 24px;
  bottom: 24px;

  height: 50px;
  padding: 0 18px;

  display: flex;
  align-items: center;
  gap: 9px;

  border: none !important;
  border-radius: 28px !important;

  background: linear-gradient(135deg, #174ea6, #2563eb) !important;

  box-shadow:
    0 8px 25px rgba(37, 99, 235, 0.30),
    0 2px 8px rgba(0, 0, 0, 0.12);

  font-size: 14px;
  font-weight: 600;

  z-index: 1040;

  transition: all 0.25s ease;
}

.galax-agent-launcher:hover {
  transform: translateY(-3px);
  box-shadow:
    0 12px 30px rgba(37, 99, 235, 0.38),
    0 4px 12px rgba(0, 0, 0, 0.15);
}

.agent-launcher-icon {
  width: 27px;
  height: 27px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  background: rgba(255, 255, 255, 0.18);

  font-size: 17px;
}

.agent-online-dot {
  width: 7px;
  height: 7px;

  background: #35d07f;
  border: 1.5px solid white;

  border-radius: 50%;

  margin-left: 2px;
}


/* ===============================
   OFFCANVAS
================================ */

.galax-agent-drawer {
  width: 420px !important;

  border: none !important;

  box-shadow:
    -12px 0 40px rgba(0, 0, 0, 0.14);
}


/* ===============================
   HEADER
================================ */

.galax-agent-header {
  height: 76px;
  padding: 15px 18px;

  background: linear-gradient(
    135deg,
    #123d82,
    #1e5ac8
  );

  color: white;

  border-bottom: none !important;

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.agent-header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.agent-avatar {
  position: relative;

  width: 44px;
  height: 44px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 14px;

  background: rgba(255, 255, 255, 0.17);

  border: 1px solid rgba(255, 255, 255, 0.2);

  font-size: 22px;
}

.agent-status-dot {
  position: absolute;

  right: -2px;
  bottom: -2px;

  width: 11px;
  height: 11px;

  background: #2bd47c;

  border: 2px solid #174ea6;

  border-radius: 50%;
}

.agent-title {
  margin: 0;

  font-size: 16px !important;
  font-weight: 600;
}

.agent-status {
  margin-top: 3px;

  display: flex;
  align-items: center;
  gap: 5px;

  font-size: 11px;

  color: rgba(255, 255, 255, 0.78);
}

.agent-status span {
  width: 6px;
  height: 6px;

  border-radius: 50%;

  background: #39dc83;
}

.agent-close-btn {
  width: 34px;
  height: 34px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  border-radius: 9px;

  color: white;
  background: rgba(255, 255, 255, 0.1);

  font-size: 19px;

  transition: 0.2s;
}

.agent-close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}


/* ===============================
   BODY
================================ */

.galax-agent-body {
  padding: 0 !important;

  display: flex;
  flex-direction: column;

  background: #f6f8fc;

  height: calc(100vh - 76px);
}

.galax-agent-messages {
  flex: 1 1;

  overflow-y: auto;

  padding: 22px 18px 15px;
}

.galax-agent-messages::-webkit-scrollbar {
  width: 5px;
}

.galax-agent-messages::-webkit-scrollbar-thumb {
  background: #d1d8e5;
  border-radius: 10px;
}


/* ===============================
   WELCOME
================================ */

.agent-welcome {
  text-align: center;

  padding: 10px 20px 25px;
}

.welcome-icon {
  width: 58px;
  height: 58px;

  margin: 0 auto 12px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 18px;

  background: linear-gradient(
    135deg,
    #e9f1ff,
    #dbeafe
  );

  color: #2563eb;

  font-size: 28px;

  box-shadow: 0 5px 18px rgba(37, 99, 235, 0.12);
}

.agent-welcome h5 {
  margin-bottom: 6px;

  color: #172033;

  font-size: 16px;
  font-weight: 700;
}

.agent-welcome p {
  max-width: 300px;

  margin: auto;

  color: #778196;

  font-size: 12px;
  line-height: 1.5;
}


/* ===============================
   MESSAGES
================================ */

.agent-message-list {
  display: flex;
  flex-direction: column;
  gap: 13px;
}

.agent-message-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.bot-row {
  justify-content: flex-start;
}

.user-row {
  justify-content: flex-end;
}

.small-agent-avatar {
  width: 29px;
  height: 29px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;

  background: #e7efff;

  color: #2563eb;

  font-size: 15px;
}

.agent-message {
  max-width: 78%;

  padding: 10px 13px 7px;

  border-radius: 15px;

  font-size: 13px;

  line-height: 1.45;

  animation: messageAppear 0.25s ease;
}

@keyframes messageAppear {
  from {
    opacity: 0;
    transform: translateY(6px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.agent-bot-message {
  background: white;

  color: #343b4d;

  border: 1px solid #e7eaf0;

  border-bottom-left-radius: 4px;

  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.035);
}

.agent-user-message {
  background: linear-gradient(
    135deg,
    #2563eb,
    #174ea6
  );

  color: white;

  border-bottom-right-radius: 4px;

  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.18);
}

.message-text {
  white-space: pre-wrap;
  word-break: break-word;
}

.message-time {
  margin-top: 4px;

  text-align: right;

  font-size: 9px;

  opacity: 0.55;
}


/* ===============================
   TYPING INDICATOR
================================ */

.typing-message {
  display: flex;
  align-items: center;
  gap: 4px;

  padding: 12px 14px;
}

.typing-message span {
  width: 6px;
  height: 6px;

  border-radius: 50%;

  background: #8b96aa;

  animation: typing 1.2s infinite ease-in-out;
}

.typing-message span:nth-child(2) {
  animation-delay: 0.15s;
}

.typing-message span:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes typing {
  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.4;
  }

  30% {
    transform: translateY(-4px);
    opacity: 1;
  }
}


/* ===============================
   COMPOSER
================================ */

.galax-agent-composer {
  padding: 12px 16px 14px;

  background: white;

  border-top: 1px solid #e9ecf2;
}

.composer-box {
  min-height: 46px;

  display: flex;
  align-items: center;

  padding: 4px 5px 4px 13px;

  background: #f7f8fb;

  border: 1px solid #e1e5ed;

  border-radius: 14px;

  transition: 0.2s;
}

.composer-box:focus-within {
  background: white;

  border-color: #8db1f7;

  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08);
}

.composer-box textarea {
  flex: 1 1;

  min-height: 34px;
  max-height: 100px;

  padding: 7px 4px;

  resize: none;

  border: none !important;

  background: transparent !important;

  box-shadow: none !important;

  font-size: 13px;
}

.composer-box textarea::placeholder {
  color: #9aa3b4;
}

.agent-send-btn {
  width: 35px;
  height: 35px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  border-radius: 10px;

  background: #2563eb;

  color: white;

  font-size: 15px;

  transition: 0.2s;
}

.agent-send-btn:hover:not(:disabled) {
  background: #174ea6;
  transform: scale(1.04);
}

.agent-send-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.composer-hint {
  margin-top: 6px;

  text-align: center;

  color: #a0a8b7;

  font-size: 9px;
}

.composer-hint strong {
  color: #7b8494;
}


/* ===============================
   MOBILE
================================ */

@media (max-width: 576px) {
  .galax-agent-drawer {
    width: 100% !important;
  }

  .galax-agent-launcher {
    right: 15px;
    bottom: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/AI Agent/Styles/agentChat.css"],"names":[],"mappings":";AACA;;kCAEkC;;AAElC;EACE,eAAe;EACf,WAAW;EACX,YAAY;;EAEZ,YAAY;EACZ,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,uBAAuB;EACvB,8BAA8B;;EAE9B,gEAAgE;;EAEhE;;iCAE+B;;EAE/B,eAAe;EACf,gBAAgB;;EAEhB,aAAa;;EAEb,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B;;kCAEgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;;EAElB,qCAAqC;;EAErC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;;EAEX,mBAAmB;EACnB,yBAAyB;;EAEzB,kBAAkB;;EAElB,gBAAgB;AAClB;;;AAGA;;kCAEkC;;AAElC;EACE,uBAAuB;;EAEvB,uBAAuB;;EAEvB;oCACkC;AACpC;;;AAGA;;kCAEkC;;AAElC;EACE,YAAY;EACZ,kBAAkB;;EAElB;;;;GAIC;;EAED,YAAY;;EAEZ,8BAA8B;;EAE9B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;;EAElB,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,mBAAmB;;EAEnB,qCAAqC;;EAErC,0CAA0C;;EAE1C,eAAe;AACjB;;AAEA;EACE,kBAAkB;;EAElB,WAAW;EACX,YAAY;;EAEZ,WAAW;EACX,YAAY;;EAEZ,mBAAmB;;EAEnB,yBAAyB;;EAEzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;;EAET,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,eAAe;;EAEf,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,WAAW;;EAEX,kBAAkB;;EAElB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,YAAY;EACZ,kBAAkB;;EAElB,YAAY;EACZ,oCAAoC;;EAEpC,eAAe;;EAEf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;;AAGA;;kCAEkC;;AAElC;EACE,qBAAqB;;EAErB,aAAa;EACb,sBAAsB;;EAEtB,mBAAmB;;EAEnB,0BAA0B;AAC5B;;AAEA;EACE,SAAO;;EAEP,gBAAgB;;EAEhB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;;kCAEkC;;AAElC;EACE,kBAAkB;;EAElB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,mBAAmB;;EAEnB;;;;GAIC;;EAED,cAAc;;EAEd,eAAe;;EAEf,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;;EAEhB,YAAY;;EAEZ,cAAc;;EAEd,eAAe;EACf,gBAAgB;AAClB;;;AAGA;;kCAEkC;;AAElC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,cAAc;;EAEd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,mBAAmB;;EAEnB,mBAAmB;;EAEnB,cAAc;;EAEd,eAAe;AACjB;;AAEA;EACE,cAAc;;EAEd,sBAAsB;;EAEtB,mBAAmB;;EAEnB,eAAe;;EAEf,iBAAiB;;EAEjB,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;;EAEjB,cAAc;;EAEd,yBAAyB;;EAEzB,8BAA8B;;EAE9B,2CAA2C;AAC7C;;AAEA;EACE;;;;GAIC;;EAED,YAAY;;EAEZ,+BAA+B;;EAE/B,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;;EAEf,iBAAiB;;EAEjB,cAAc;;EAEd,aAAa;AACf;;;AAGA;;kCAEkC;;AAElC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;;EAEX,kBAAkB;;EAElB,mBAAmB;;EAEnB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;;IAGE,wBAAwB;IACxB,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;;;AAGA;;kCAEkC;;AAElC;EACE,uBAAuB;;EAEvB,iBAAiB;;EAEjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;;EAEhB,aAAa;EACb,mBAAmB;;EAEnB,yBAAyB;;EAEzB,mBAAmB;;EAEnB,yBAAyB;;EAEzB,mBAAmB;;EAEnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;;EAEjB,qBAAqB;;EAErB,6CAA6C;AAC/C;;AAEA;EACE,SAAO;;EAEP,gBAAgB;EAChB,iBAAiB;;EAEjB,gBAAgB;;EAEhB,YAAY;;EAEZ,uBAAuB;;EAEvB,kCAAkC;;EAElC,2BAA2B;;EAE3B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,cAAc;;EAEd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,YAAY;EACZ,mBAAmB;;EAEnB,mBAAmB;;EAEnB,YAAY;;EAEZ,eAAe;;EAEf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;;EAEf,kBAAkB;;EAElB,cAAc;;EAEd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;;kCAEkC;;AAElC;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["\n/* ===============================\n   AI LAUNCHER\n================================ */\n\n.galax-agent-launcher {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n\n  height: 50px;\n  padding: 0 18px;\n\n  display: flex;\n  align-items: center;\n  gap: 9px;\n\n  border: none !important;\n  border-radius: 28px !important;\n\n  background: linear-gradient(135deg, #174ea6, #2563eb) !important;\n\n  box-shadow:\n    0 8px 25px rgba(37, 99, 235, 0.30),\n    0 2px 8px rgba(0, 0, 0, 0.12);\n\n  font-size: 14px;\n  font-weight: 600;\n\n  z-index: 1040;\n\n  transition: all 0.25s ease;\n}\n\n.galax-agent-launcher:hover {\n  transform: translateY(-3px);\n  box-shadow:\n    0 12px 30px rgba(37, 99, 235, 0.38),\n    0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.agent-launcher-icon {\n  width: 27px;\n  height: 27px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 50%;\n\n  background: rgba(255, 255, 255, 0.18);\n\n  font-size: 17px;\n}\n\n.agent-online-dot {\n  width: 7px;\n  height: 7px;\n\n  background: #35d07f;\n  border: 1.5px solid white;\n\n  border-radius: 50%;\n\n  margin-left: 2px;\n}\n\n\n/* ===============================\n   OFFCANVAS\n================================ */\n\n.galax-agent-drawer {\n  width: 420px !important;\n\n  border: none !important;\n\n  box-shadow:\n    -12px 0 40px rgba(0, 0, 0, 0.14);\n}\n\n\n/* ===============================\n   HEADER\n================================ */\n\n.galax-agent-header {\n  height: 76px;\n  padding: 15px 18px;\n\n  background: linear-gradient(\n    135deg,\n    #123d82,\n    #1e5ac8\n  );\n\n  color: white;\n\n  border-bottom: none !important;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.agent-header-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.agent-avatar {\n  position: relative;\n\n  width: 44px;\n  height: 44px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 14px;\n\n  background: rgba(255, 255, 255, 0.17);\n\n  border: 1px solid rgba(255, 255, 255, 0.2);\n\n  font-size: 22px;\n}\n\n.agent-status-dot {\n  position: absolute;\n\n  right: -2px;\n  bottom: -2px;\n\n  width: 11px;\n  height: 11px;\n\n  background: #2bd47c;\n\n  border: 2px solid #174ea6;\n\n  border-radius: 50%;\n}\n\n.agent-title {\n  margin: 0;\n\n  font-size: 16px !important;\n  font-weight: 600;\n}\n\n.agent-status {\n  margin-top: 3px;\n\n  display: flex;\n  align-items: center;\n  gap: 5px;\n\n  font-size: 11px;\n\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.agent-status span {\n  width: 6px;\n  height: 6px;\n\n  border-radius: 50%;\n\n  background: #39dc83;\n}\n\n.agent-close-btn {\n  width: 34px;\n  height: 34px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border: none;\n  border-radius: 9px;\n\n  color: white;\n  background: rgba(255, 255, 255, 0.1);\n\n  font-size: 19px;\n\n  transition: 0.2s;\n}\n\n.agent-close-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n\n/* ===============================\n   BODY\n================================ */\n\n.galax-agent-body {\n  padding: 0 !important;\n\n  display: flex;\n  flex-direction: column;\n\n  background: #f6f8fc;\n\n  height: calc(100vh - 76px);\n}\n\n.galax-agent-messages {\n  flex: 1;\n\n  overflow-y: auto;\n\n  padding: 22px 18px 15px;\n}\n\n.galax-agent-messages::-webkit-scrollbar {\n  width: 5px;\n}\n\n.galax-agent-messages::-webkit-scrollbar-thumb {\n  background: #d1d8e5;\n  border-radius: 10px;\n}\n\n\n/* ===============================\n   WELCOME\n================================ */\n\n.agent-welcome {\n  text-align: center;\n\n  padding: 10px 20px 25px;\n}\n\n.welcome-icon {\n  width: 58px;\n  height: 58px;\n\n  margin: 0 auto 12px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 18px;\n\n  background: linear-gradient(\n    135deg,\n    #e9f1ff,\n    #dbeafe\n  );\n\n  color: #2563eb;\n\n  font-size: 28px;\n\n  box-shadow: 0 5px 18px rgba(37, 99, 235, 0.12);\n}\n\n.agent-welcome h5 {\n  margin-bottom: 6px;\n\n  color: #172033;\n\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.agent-welcome p {\n  max-width: 300px;\n\n  margin: auto;\n\n  color: #778196;\n\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n\n/* ===============================\n   MESSAGES\n================================ */\n\n.agent-message-list {\n  display: flex;\n  flex-direction: column;\n  gap: 13px;\n}\n\n.agent-message-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.bot-row {\n  justify-content: flex-start;\n}\n\n.user-row {\n  justify-content: flex-end;\n}\n\n.small-agent-avatar {\n  width: 29px;\n  height: 29px;\n\n  flex-shrink: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 10px;\n\n  background: #e7efff;\n\n  color: #2563eb;\n\n  font-size: 15px;\n}\n\n.agent-message {\n  max-width: 78%;\n\n  padding: 10px 13px 7px;\n\n  border-radius: 15px;\n\n  font-size: 13px;\n\n  line-height: 1.45;\n\n  animation: messageAppear 0.25s ease;\n}\n\n@keyframes messageAppear {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.agent-bot-message {\n  background: white;\n\n  color: #343b4d;\n\n  border: 1px solid #e7eaf0;\n\n  border-bottom-left-radius: 4px;\n\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.035);\n}\n\n.agent-user-message {\n  background: linear-gradient(\n    135deg,\n    #2563eb,\n    #174ea6\n  );\n\n  color: white;\n\n  border-bottom-right-radius: 4px;\n\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.18);\n}\n\n.message-text {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.message-time {\n  margin-top: 4px;\n\n  text-align: right;\n\n  font-size: 9px;\n\n  opacity: 0.55;\n}\n\n\n/* ===============================\n   TYPING INDICATOR\n================================ */\n\n.typing-message {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  padding: 12px 14px;\n}\n\n.typing-message span {\n  width: 6px;\n  height: 6px;\n\n  border-radius: 50%;\n\n  background: #8b96aa;\n\n  animation: typing 1.2s infinite ease-in-out;\n}\n\n.typing-message span:nth-child(2) {\n  animation-delay: 0.15s;\n}\n\n.typing-message span:nth-child(3) {\n  animation-delay: 0.3s;\n}\n\n@keyframes typing {\n  0%,\n  60%,\n  100% {\n    transform: translateY(0);\n    opacity: 0.4;\n  }\n\n  30% {\n    transform: translateY(-4px);\n    opacity: 1;\n  }\n}\n\n\n/* ===============================\n   COMPOSER\n================================ */\n\n.galax-agent-composer {\n  padding: 12px 16px 14px;\n\n  background: white;\n\n  border-top: 1px solid #e9ecf2;\n}\n\n.composer-box {\n  min-height: 46px;\n\n  display: flex;\n  align-items: center;\n\n  padding: 4px 5px 4px 13px;\n\n  background: #f7f8fb;\n\n  border: 1px solid #e1e5ed;\n\n  border-radius: 14px;\n\n  transition: 0.2s;\n}\n\n.composer-box:focus-within {\n  background: white;\n\n  border-color: #8db1f7;\n\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08);\n}\n\n.composer-box textarea {\n  flex: 1;\n\n  min-height: 34px;\n  max-height: 100px;\n\n  padding: 7px 4px;\n\n  resize: none;\n\n  border: none !important;\n\n  background: transparent !important;\n\n  box-shadow: none !important;\n\n  font-size: 13px;\n}\n\n.composer-box textarea::placeholder {\n  color: #9aa3b4;\n}\n\n.agent-send-btn {\n  width: 35px;\n  height: 35px;\n\n  flex-shrink: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border: none;\n  border-radius: 10px;\n\n  background: #2563eb;\n\n  color: white;\n\n  font-size: 15px;\n\n  transition: 0.2s;\n}\n\n.agent-send-btn:hover:not(:disabled) {\n  background: #174ea6;\n  transform: scale(1.04);\n}\n\n.agent-send-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.composer-hint {\n  margin-top: 6px;\n\n  text-align: center;\n\n  color: #a0a8b7;\n\n  font-size: 9px;\n}\n\n.composer-hint strong {\n  color: #7b8494;\n}\n\n\n/* ===============================\n   MOBILE\n================================ */\n\n@media (max-width: 576px) {\n  .galax-agent-drawer {\n    width: 100% !important;\n  }\n\n  .galax-agent-launcher {\n    right: 15px;\n    bottom: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
